import { render } from "./AllTabs.vue?vue&type=template&id=29b307c2"
import script from "./AllTabs.vue?vue&type=script&lang=js"
export * from "./AllTabs.vue?vue&type=script&lang=js"

import "./AllTabs.vue?vue&type=style&index=0&id=29b307c2&lang=css"

import exportComponent from "D:\\Pranav\\Coding\\MyProjects\\Own Projects\\todo_list_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__